import type { EditorState } from 'draft-js';
import type { FC } from 'types/react';

import { isStyleApplied } from '../../helpers/is-style-applied';
import { ItalicIcon } from './static_assets';
import { Button } from './styles';

interface Props {
    editorState: EditorState;
    onClick: () => void;
}

export const ItalicButton: FC<Props> = ({ editorState, onClick }) => (
    <Button $isActive={isStyleApplied('ITALIC', editorState)} onClick={onClick}>
        <ItalicIcon />
    </Button>
);
